import React, { useState } from "react";
import EmployeeTable from "./EmployeeTable";
import RoleTable from "./RoleTable";
import PermissionTable from "./PermissionTable";

const TabbedStaffTable = ({
  employeeData,
  rolesData,
  permissionsData,
  rawEmployeeData,
  isFetchingEmployees,
  isFetchingRoles,
  isFetchingPermissions,
  activeTab,
  onTabChange,
  onAddEmployee,
  onBulkImport,
  onEditEmployee,
  onViewEmployee,
  onDeleteEmployee,
  onDownloadProfile,
  onAddRole,
  onImportRoles,
  onViewRole,
  onEditRole,
  onDeleteRole,
  onAssignUsers,
  onManagePermissions,
  onAddPermission,
  onRemovePermission,
  onViewPermission,
  onEditPermission,
  onImportPermissions,
  onBulkDeleteEmployee,
  onBulkEditEmployee,
  onBulkDeleteRole,
  onBulkEditRole,
  onBulkDeletePermission,
  onBulkEditPermission,
  // NEW: Pagination props for each tab
  employeesPaginationInfo,
  onEmployeesPageChange,
  onEmployeesPageSizeChange,
  rolesPaginationInfo,
  onRolesPageChange,
  onRolesPageSizeChange,
  permissionsPaginationInfo,
  onPermissionsPageChange,
  onPermissionsPageSizeChange,
  // NEW: Search handlers for each tab
  onEmployeesSearch,
  onRolesSearch,
  onPermissionsSearch,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const handleTabChange = (newTab) => {
    // console.log('Tab changing from', activeTab, 'to', newTab);
    onTabChange(newTab);
    setSelectedRowKeys([]);
  };

  // Define tabs with dynamic counts from pagination total
  const orderTabs = [
    {
      label: "Staff",
      badgeContent: employeesPaginationInfo?.total || employeeData.length,
    },
    {
      label: "Roles",
      badgeContent: rolesPaginationInfo?.total || rolesData.length,
    },
    {
      label: "Permission",
      badgeContent:
        permissionsPaginationInfo?.total || permissionsData?.length || 0,
    },
  ];

  const renderTable = () => {
    if (activeTab === 0) {
      return (
        <EmployeeTable
          employeeData={employeeData}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          searchValue=""
          isFetching={isFetchingEmployees}
          onAddEmployee={onAddEmployee}
          onBulkImport={onBulkImport}
          onEditEmployee={onEditEmployee}
          onViewEmployee={onViewEmployee}
          onDeleteEmployee={onDeleteEmployee}
          onDownloadProfile={onDownloadProfile}
          rawEmployeeData={rawEmployeeData}
          tabs={orderTabs}
          activeTab={activeTab}
          onTabChange={handleTabChange}
          onBulkDelete={onBulkDeleteEmployee}
          onBulkEdit={onBulkEditEmployee}
          // Pagination props
          paginationInfo={employeesPaginationInfo}
          onPageChange={onEmployeesPageChange}
          onPageSizeChange={onEmployeesPageSizeChange}
          // Search props - pass the API search handler directly
          onSearchChange={onEmployeesSearch}
        />
      );
    } else if (activeTab === 1) {
      return (
        <RoleTable
          rolesData={rolesData}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          searchValue=""
          isFetching={isFetchingRoles}
          onAddRole={onAddRole}
          onImportRoles={onImportRoles}
          onViewRole={onViewRole}
          onEditRole={onEditRole}
          onDeleteRole={onDeleteRole}
          onAssignUsers={onAssignUsers}
          onManagePermissions={onManagePermissions}
          tabs={orderTabs}
          activeTab={activeTab}
          onTabChange={handleTabChange}
          onBulkDelete={onBulkDeleteRole}
          onBulkEdit={onBulkEditRole}
          // Pagination props
          paginationInfo={rolesPaginationInfo}
          onPageChange={onRolesPageChange}
          onPageSizeChange={onRolesPageSizeChange}
          // Search props
          onSearchChange={onRolesSearch}
        />
      );
    } else if (activeTab === 2) {
      return (
        <PermissionTable
          permissionsData={permissionsData || []}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          searchValue=""
          isFetching={isFetchingPermissions}
          onAddPermission={onAddPermission}
          onRemovePermission={onRemovePermission}
          onImportPermissions={onImportPermissions}
          onViewPermission={onViewPermission}
          onEditPermission={onEditPermission}
          tabs={orderTabs}
          activeTab={activeTab}
          onTabChange={handleTabChange}
          onBulkDelete={onBulkDeletePermission}
          onBulkEdit={onBulkEditPermission}
          // Pagination props
          paginationInfo={permissionsPaginationInfo}
          onPageChange={onPermissionsPageChange}
          onPageSizeChange={onPermissionsPageSizeChange}
          // Search props
          onSearchChange={onPermissionsSearch}
        />
      );
    }
    return null;
  };

  return (
    <div>
      <style>{`
        .modal-right .ant-modal { max-width: none; padding: 0; }
        .modal-right .ant-modal-content { height: 100vh; border-radius: 0; overflow: hidden; display: flex; flex-direction: column; top: 0; }
        .modal-right .ant-modal-body { height: 100%; padding: 0; display: flex; flex-direction: column; flex: 1; max-height: 100vh; }
        .modal-right .ant-modal-footer { position: sticky; bottom: 0; background: white; border-top: 1px solid #e5e7eb; z-index: 10; }
        .ant-modal-close { z-index: 1000; }
        .ant-input[readonly], .ant-select-disabled, .ant-picker-disabled { cursor: not-allowed !important; }
      `}</style>
      {renderTable()}
    </div>
  );
};

export default TabbedStaffTable;
